import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { districtsListApi } from "Apis/member";

export const TalukaContext = createContext();

export const TalukaContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [districtList, setDistrictList] = useState([]);

  const getDistrictApi = async () => {
    let response = await districtsListApi();
    if (response?.status === 200) {
      setDistrictList(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <TalukaContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        districtList,
        setDistrictList,
        getDistrictApi,
      }}
    >
      {children}
    </TalukaContext.Provider>
  );
};

export default TalukaContextProvider;
TalukaContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
